'use client';

import { use } from 'react';

import { WidgetContext } from '../context/widget-context';

export const useDocumentShare = () => {
   const {
      shareDocumentList = {
         detailPageName: '',
         documents: []
      },
      setShareList = () => {},
      downloadDocumentList = [],
      setDownloadList = () => {}
   } = use(WidgetContext) ?? {};

   return { shareDocumentList, setShareList, setDownloadList, downloadDocumentList };
};
